import {PortableText} from '@portabletext/react';
import {getFileAsset} from '@sanity/asset-utils';

import Code from '../Code';
import BlogImageWithCaption from '../BlogImageWithCaption';
import BlogVideoWithCaption from '../BlogVideoWithCaption';
import YoutubePreview from './YoutubePreview';
import IframePreview from './IframePreview';
import client from 'utils/sanity.api';
import {urlFor} from 'utils/sanity.image';

const SanityPostRenderer = ({post}) => {
  const ptComponents = {
    types: {
      image: ({value}) => {
        if (!value?.asset?._ref) {
          return null;
        }
        return (
          <BlogImageWithCaption
            caption={value.caption}
            alt={value.caption}
            src={urlFor(value).url()}
          />
        );
      },
      'Video file': ({value}) => {
        if (!value?.asset?._ref) {
          return null;
        }
        const videoAsset = getFileAsset(value.asset, client.config());

        return (
          <BlogVideoWithCaption caption={value.caption} alt={value.caption} src={videoAsset.url} />
        );
      },
      code: props => (
        <pre className="my-2">
          <Code className="" language={props.value.language}>
            {props.value.code}
          </Code>
        </pre>
      ),
      youtube: ({value}) => {
        return <YoutubePreview node={value} />;
      },
      iframe: ({value}) => {
        return <IframePreview node={value} />;
      },
    },
  };

  const {body = []} = post;

  return <PortableText value={body} components={ptComponents} />;
};

export default SanityPostRenderer;
